export const maxImageBytes = 5 * 1024 * 1024;

const imageName = /\.(png|jpe?g|gif|webp|avif|svg)$/i;

export function isImageFile(file: File) {
  return file.type.startsWith("image/") || imageName.test(file.name);
}

/** Stores an image in the site bucket and returns the address to use in Markdown. */
export async function uploadImage(file: File) {
  if (file.size > maxImageBytes) throw new Error("Images must be 5 MB or smaller.");
  const body = new FormData();
  body.append("file", file, file.name || "image");
  const response = await fetch("/api/images", { method: "POST", body });
  const payload = (await response.json().catch(() => null)) as { url?: string; error?: string } | null;
  if (!response.ok || !payload?.url) throw new Error(payload?.error ?? "Unable to upload this image.");
  return payload.url;
}
